"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VizPortalWebClientRequester_1 = require("../api/VizPortalWebClientRequester");
var WebClientFetchRequester_1 = require("../requester/WebClientFetchRequester");
/**
 * Create a vizportalWebClientRequester given web client prefix and hostName.
 */
function vizPortalWebClientRequesterGenerator(apiPrefix, hostName) {
    if (apiPrefix === void 0) { apiPrefix = WebClientFetchRequester_1.VIZPORTAL_API_PATH; }
    if (hostName === void 0) { hostName = ''; }
    return new VizPortalWebClientRequester_1.VizPortalWebClientRequester(new WebClientFetchRequester_1.WebClientFetchRequester(apiPrefix, hostName));
}
exports.vizPortalWebClientRequesterGenerator = vizPortalWebClientRequesterGenerator;
//# sourceMappingURL=vizPortalWebClientRequesterGenerator.js.map